<div class="aside-title">
    <h6 *ngIf="caption || iconClassName" class="title">
        <i *ngIf="iconClassName" class="text-muted fa fa-{{iconClassName}}"></i>
        <span *ngIf="caption && iconClassName">&nbsp;</span>{{caption}}
    </h6>
    <div class="float-end">
        <jbm-cross-close-button (click)="close()"></jbm-cross-close-button>
    </div>
</div>